import * as React from "react";
import { Context } from "./_context";
export const ImageIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21.602 3.505a1 1 0 0 1 .898.995v15a1 1 0 0 1-1 1h-19a1 1 0 0 1-1-1v-15l.005-.103A1 1 0 0 1 2.5 3.5h19l.102.005ZM3.5 18.5h17v-13h-17v13Zm7.932-8.822a1 1 0 0 1 1.209.053l6 5A1.001 1.001 0 0 1 18 16.5H6a1 1 0 0 1-.64-1.769l6-5 .072-.053ZM8.762 14.5h6.475L12 11.802 8.763 14.5ZM7 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z", fill: "currentColor" }));
  return iconset[size];
};
ImageIcon.iconId = "GG9TWS";
